function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "100%",
  id: "TeamSelected_svg__5_a"
}, React.createElement("stop", {
  stopColor: "#4DB1FD",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#148CFC",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 0a8 8 0 110 16A8 8 0 018 0zm.007 8.28c-1.562 0-2.828 1.252-2.828 2.797 0 .171.015.339.045.503.715.519 1.698.84 2.783.84s2.068-.321 2.782-.841c.03-.163.046-.33.046-.502 0-1.545-1.266-2.797-2.828-2.797zm2.821-.56c-.465 0-.897.14-1.257.378a3.352 3.352 0 011.83 2.979l-.003-.116c.753-.257 1.353-.78 1.65-1.436a2.257 2.257 0 00-2.22-1.805zm-5.656 0c-1.1 0-2.016.776-2.22 1.805.299.66.904 1.185 1.663 1.439A3.354 3.354 0 016.435 8.1a2.27 2.27 0 00-1.263-.38zm2.835-3.356c-.937 0-1.697.751-1.697 1.678 0 .927.76 1.678 1.697 1.678s1.696-.751 1.696-1.678c0-.927-.76-1.678-1.696-1.678zm2.821.56c-.278 0-.534.099-.73.265a2.21 2.21 0 010 1.707c.196.165.452.265.73.265.625 0 1.131-.501 1.131-1.119s-.506-1.119-1.13-1.119zm-5.656 0c-.625 0-1.131.5-1.131 1.118 0 .618.506 1.119 1.131 1.119.283 0 .542-.103.74-.274a2.21 2.21 0 010-1.691 1.134 1.134 0 00-.74-.273z",
  fill: "url(#TeamSelected_svg__5_a)",
  fillRule: "evenodd"
});

var SvgTeamSelected = function SvgTeamSelected(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
};

export default SvgTeamSelected;